import qs from 'qs';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { getDateRangeFromCalendar } from '../../shared/calendar';
import { getGroupValues } from '../../shared/groups';

export default (statisticsState, externalQuery = {}) => {
	const { query, calendar, filters: { selectedFilters }, groups = null } = cloneDeep(statisticsState);
	const dateRange = getDateRangeFromCalendar(calendar);

	if (dateRange) {
		query['date_range'] = dateRange;
	}
	if (externalQuery.external_conv_id) { //when url query contains id extend date_range to year
		query['date_range'].start = moment(dateRange.start)
			.subtract(36, 'month')
			.format('YYYY-MM-DD HH:mm:ss.SSS');
	}

	if (selectedFilters) {
		const filters = {};
		const inverseFilters = {};

		selectedFilters.forEach(filter => {
			const values = filter.value.map(f => f.value);
			if (values.length) {
				const selectedFilterValues = filter.shouldInverse ? inverseFilters : filters;
				selectedFilterValues[filter.name] = values;
			}
		});

		query['filters'] = !isEmpty(filters) ? filters : {};
		query['inverse_filters'] = !isEmpty(inverseFilters) ? inverseFilters : {};
	}

	if (groups) {
		const { listOfControls, orderControlsDuration } = groups;
		const groupValues = getGroupValues(listOfControls, orderControlsDuration);
		groupValues && (query['groups'] = groupValues);
	}

	const externalQueryPrepare = isEmpty(externalQuery) ? {} : {
		...externalQuery,
		currency: externalQuery.currency ? externalQuery.currency: undefined
	};

	return qs.stringify({
		...query,
		...externalQueryPrepare
	});
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/shared/get-request-query.js